import { render, staticRenderFns } from "./SaleOrderImport.vue?vue&type=template&id=573fb41c&scoped=true"
import script from "./SaleOrderImport.vue?vue&type=script&lang=js"
export * from "./SaleOrderImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573fb41c",
  null
  
)

export default component.exports